import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { CFDocumentToDisplay } from '../../models/cf-document/cf-document-to-display';
import { CFSignatureStoreService } from '../signatures/cf-signature-store.service';
import { CFDocumentStoreService } from './cf-document-store.service';
import { CFDocumentService } from './cf-document.service';

@Injectable({ providedIn: 'root' })
export class CFDocumentResolver implements Resolve<CFDocumentToDisplay> {
    constructor(
        private documentService: CFDocumentService,
        private documentStoreService: CFDocumentStoreService,
        private signatureStoreService: CFSignatureStoreService
    ) {}

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<CFDocumentToDisplay> | Promise<CFDocumentToDisplay> | CFDocumentToDisplay {
        this.documentStoreService.resetFilters();
        this.signatureStoreService.signatureId = route.paramMap.get('signatureId');

        const routeDocumentType = parseInt(route.paramMap.get('documentType'));

        if (isNaN(routeDocumentType)) {
            this.documentStoreService.selectedDocumentType = 0;
        } else {
            this.documentStoreService.selectedDocumentType = routeDocumentType;
        }

        this.documentStoreService.documentNumber = route.paramMap.get('documentNumber');
        this.documentStoreService.companyId = route.paramMap.get('companyId');

        return new Promise((resolve, reject) => {
            this.documentService
                .getDocument(
                    this.documentStoreService.selectedDocumentType,
                    this.documentStoreService.companyId,
                    this.documentStoreService.documentNumber
                )
                .subscribe((document: CFDocumentToDisplay) => {
                    resolve(document);
                });
        });
    }
}
